import React from "react";
import ErrorPopupRacing from '../Racing';
import './index.scss'

const ErrorPopupTV = ({...props})=> {
    const isIPad = ()=> {
        const userAgent = navigator.userAgent;
        return /iPad|iPod/.test(userAgent);
    }
       
    return <ErrorPopupRacing className={`${isIPad() ? 'isIPad' : ''} ErrorPopupTV`} {...props}></ErrorPopupRacing>
}
export default ErrorPopupTV